import moment from 'moment';
import utils from './utils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Heading from '@/components/pageheader_component.vue';
import Popover from '@/components/popover_component.vue';
import axios from 'axios';
import ProductsImageMode from '@/components/product_list_model.vue'
import LoaderPopover from '@/components/loaderpopover_component.vue';
export default {
    name: 'Newbooking',
    components: {
        DatePicker,
        Heading,
        LoaderPopover,
        Popover,
        ProductsImageMode
    },
    data() {
        return{
            is_submitting:false, // JOYWEB-2801: in-flight guard to prevent duplicate booking submits
            url:window.location.protocol+'//'+window.location.hostname+'/index.php/',
            cards:[{index:0,service_index:'S1'}],
            serv_start_time:Date,
            serv_end_time:Date,
            search_customer:false,
            edit_customer_notes : false,
            cust_details:'',
            services_list:[],
            customer_id:'',
            booking_date:new Date(),
            multibooking:[{services_list:[],serv_id:'',user_id:'',book_fullamount:0,user_staff_type_id:'',book_deposit:0,book_staff_note:'',book_start_date:this.booking_date,book_end_date:this.booking_date, serv_start_time:'',serv_end_time:'',serv_duration:'',pre_buffer:'',post_buffer:'',serv_cat_id:'',error_message:'',unmapped_selected_error:false,endtime_mismatch:false}],
            customers_list:[],
            staff:[],
            update_customer_array:false,
            booking_staff_notes:'',
            booking_total:0,
            get_customer_info:'',
            store_id:'',
            onload:true,
            send_mail:false,
            send_text:false,
            booked_services:[],
            title:'New Booking',
            remove_type:'',
            popup_type:'',
            remove_service_index:'',  
            remove_popup:false ,
            changes_happened:false,
            button1:'',
            button2:'',
            previous_booking_details:[],
            deposite_amount:0,
            full_amount:0,
            payed_full_amount:0,
            show_product_model:false,
            products_list:[],
            previous_products:[],
            selected_product_index:'',
            service_changed:false,
        }
    },
    filters: {
        human_date_format: function (date) {
            return moment(date).format('DD MMM YYYY, hh:mm A');
        },
        
    },
    created(){
        this.$store.state.loader_popup = true;
        this.store_id = this.$session.get('store_id');
        if(!this.$session.has('has_products_in_page'))this.$store.state.selected_products = [];
        this.$session.remove('selected_product_id')
        this.get_staff();
    },
    computed:{
        get_current_date(){
            if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') this.update_button_text();
            return moment(this.booking_date).format('ddd, MMM D, YYYY')
        }
    },
    mounted(){
        this.booking_date = this.$store.state.selected_date;
        this.$session.remove('edit_cust_id');
        if(this.$session.has('bookings_list_new_booking_page')){
            this.cards = []
            this.multibooking = this.$session.get('bookings_list_new_booking_page');
            var index = 0;
            this.multibooking.forEach(booking => {
                this.get_services_by_staff_id(booking.user_id,index,false)
                this.booking_total += booking.book_fullamount;
                this.cards.push({index:index,service_index:`S${index+1}`});
                index++;
                this.$session.remove('bookings_list_new_booking_page');
            });
            if(this.$session.has('created_cust_id')) this.get_customer_details(this.$session.get('created_cust_id'));
            else if(this.$session.has('booking_customer_id')) this.get_customer_details(this.$session.get('booking_customer_id'));
            this.$session.remove('booking_customer_id');
            this.title = this.$session.get('page_title');
            this.previous_booking_details = this.$session.get('previous_booking');
            this.previous_products = this.$session.get('previous_products');
        }
        else if(this.$session.get('rebook')){
            this.get_services();
        }
        else if(this.$session.get('editbooking')) {
            this.get_services_of_edit_booking();
        }
    },
    beforeDestroy() {
        this.$session.remove('rebook')
    },
    methods:{
        async get_services(){
            axios.post(this.$store.state.api+`transactions/get_bookings_payment_amount`,{
                "book_id": this.$session.get('book_id'),
                "multi_book_id":this.$session.get('multi_book_id')
            }).then(response => {
                this.get_services_by_staff_id(response.data.result.bookings[0].user_id,0,true);
                this.get_customer_details(response.data.result.bookings[0].cust_id);
                this.multibooking[0].serv_id = response.data.result.bookings[0].serv_id;
                this.multibooking[0].pre_buffer = response.data.result.bookings[0].book_prebuffertime;
                this.multibooking[0].post_buffer = response.data.result.bookings[0].book_postbuffertime;
                this.multibooking[0].book_fullamount = response.data.result.bookings[0].serv_saleprice;
                this.multibooking[0].book_discount_full_amount = response.data.result.bookings[0].book_discount_full_amount;
                this.multibooking[0].book_deposit = response.data.result.bookings[0].serv_deposit;
                this.multibooking[0].book_discount_deposit_amount = response.data.result.bookings[0].book_discount_deposit_amount;
                this.$store.state.selected_products = [];
                var product_details = {};
                response.data.result.products.forEach(async product => {
                    await this.$store.dispatch('get_product_details',[this.$store.state.api,[product.product_id]]);
                    product.product_remaining_quantity = this.$store.state.product_image_url_data.product_quantity;
                    product_details={
                        "booking_product_id":product.booking_product_id,
                        "product_id": product.product_id,
                        "product_name":product.product_name,
                        "product_sku":product.product_sku,
                        "product_barcode":product.product_barcode,
                        "product_default_image":{
                            "product_image_url":product.product_image_url,
                            "product_thumbnail_url":product.product_thumbnail_url
                        },
                        "selected_quantity": product.product_quantity, 
                        "product_quantity":product.product_remaining_quantity,
                        "product_sale_price": product.product_full_amount, 
                        "product_price":product.product_compare_price
                       }
                       if(product.product_discount_full_amount && (product.product_discount_full_amount != -1))product_details.product_sale_price = product.product_discount_full_amount;
                      this.$store.state.selected_products.push(product_details);
                    //   this.previous_products.push(product_details);
                });
                this.previous_products = JSON.parse(JSON.stringify(this.$store.state.selected_products));
                this.full_amount = response.data.result.pay_fullamount;
                this.deposite_amount = response.data.result.pay_deposit;
                if(this.deposite_amount == 0 && this.full_amount != 0){
                    this.button1 = 'Close';
                    this.button2 = 'Pay balance'
                }
                else if(this.deposite_amount != 0){
                    this.button1 = 'Close';
                    this.button2 = 'Pay now'
                }
                var bookings = response.data.result.bookings;
                for(var index = 0; index < bookings.length; index++){
                    if(bookings[index].due_book_deposit == 0) this.payed_deposite += bookings[index].book_deposit;
                    if(bookings[index].due_book_fullamount <= 0) this.payed_full_amount += bookings[index].book_fullamount;
                } 
                this.update_total_value();
            })
        },
        get_services_of_edit_booking(){
            this.title = 'Edit Booking';
            this.cards=[];
            this.multibooking = [];
            axios.post(this.$store.state.api+`transactions/get_bookings_payment_amount`,{
                "book_id": this.$session.get('book_id'),
                "multi_book_id":this.$session.get('multi_book_id')
            }).then(response => {
                this.onload=false;
                this.booked_services = response.data.result.bookings;
                this.$store.state.selected_products = [];
                var product_details = {};
                response.data.result.products.forEach(product => {
                    product_details={
                        "booking_product_id":product.booking_product_id,
                        "booking_old_product_id":product.booking_old_product_id,
                        "product_id": product.product_id,
                        "product_name":product.product_name,
                        "product_sku":product.product_sku,
                        "product_barcode":product.product_barcode,
                        product_default_image:{
                            "product_image_url":product.product_image_url,
                            "product_thumbnail_url":product.product_thumbnail_url 
                        },
                        "selected_quantity": product.product_quantity, 
                        "product_quantity":(product.product_remaining_quantity+product.product_quantity),
                        "old_quantity":product.product_quantity,
                        "product_sale_price": product.product_full_amount,
                        "product_price":product.product_compare_price
                       }
                       if(product.product_discount_full_amount && (product.product_discount_full_amount != -1))product_details.product_sale_price = product.product_discount_full_amount;
                      
                      this.$store.state.selected_products.push(product_details);
                    //   this.previous_products.push(product_details);
                });
                this.previous_products = JSON.parse(JSON.stringify(this.$store.state.selected_products));
                if(this.booked_services.length < 1) {
                    alert("No Services Found....!")
                    this.$router.push('/calendar');
                }
                else{
                    this.get_customer_details(this.booked_services[0].cust_id);
                    var index=0;
                    this.booking_total = 0;
                    this.booked_services.forEach(booking => {
                        this.multibooking.push({
                            book_id:booking.book_id,
                            multi_service_book_id:booking.multi_service_book_id,
                            book_oldbookid:booking.book_oldbookid,
                            services_list:[],
                            serv_id:booking.serv_id,
                            user_id:booking.user_id,
                            book_fullamount:booking.serv_saleprice,
                            book_discount_full_amount:booking.book_discount_full_amount,
                            book_deposit:booking.serv_deposit,
                            book_discount_deposit_amount:booking.book_discount_deposit_amount, 
                            serv_start_time:moment(booking.book_start_time,["HH:mm"]).format('HH:mm'),
                            serv_end_time:moment(booking.book_end_time,["HH:mm"]).format('HH:mm'),
                            serv_duration:booking.book_duration,
                            pre_buffer:booking.book_prebuffertime,
                            post_buffer:booking.book_postbuffertime,
                            serv_cat_id:booking.serv_cat_id,
                            error_message:'',
                            unmapped_selected_error:false})
                        // if(booking.book_discount_deposit_amount != -1)this.multibooking[index].book_discount_deposit_amount = booking.book_discount_deposit_amount;
                        this.get_services_by_staff_id(booking.user_id,index,false)
                        this.booking_total += booking.book_fullamount;
                        this.cards.push({index:index,service_index:`S${index+1}`});
                        index++;
                    });
                    this.previous_booking_details = JSON.parse(JSON.stringify(this.multibooking));
                    this.booking_staff_notes=this.booked_services[0].book_staff_note;
                    if(this.$session.get('booking_type') == this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING){
                        this.title = 'Booking Reschedule';
                        var reschedule_data = this.$session.get('reschedule_data');
                        this.booking_date = reschedule_data.droped_date;
                        if(reschedule_data.is_group_move && this.multibooking.length > 1){
                            // JOYWEB-2626: move the whole back-to-back group together — shift every
                            // service by the same delta and reassign all to the target staff, so the
                            // submit payload carries all siblings with their new times/staff.
                            var delta = reschedule_data.delta_minutes || 0;
                            for(var gi = 0; gi < this.multibooking.length; gi++){
                                this.multibooking[gi].user_id = reschedule_data.selected_staff;
                                this.multibooking[gi].serv_start_time = moment(this.multibooking[gi].serv_start_time,["HH:mm"]).add(delta,'minutes').format('HH:mm');
                                this.multibooking[gi].serv_end_time = moment(this.multibooking[gi].serv_end_time,["HH:mm"]).add(delta,'minutes').format('HH:mm');
                                this.get_services_by_staff_id(reschedule_data.selected_staff, gi, false);
                            }
                        } else {
                            this.get_services_by_staff_id(reschedule_data.selected_staff,0,false)
                            this.multibooking[0].user_id = reschedule_data.selected_staff;
                            this.multibooking[0].serv_start_time = reschedule_data.start_time;
                            this.multibooking[0].serv_end_time = reschedule_data.end_time;
                        }
                    }
                    else{
                        this.booking_date = this.booked_services[0].book_start_date;
                        this.previous_booking_date = this.booking_date;
                    } 
                }

                this.full_amount = response.data.result.pay_fullamount;
                this.deposite_amount = response.data.result.pay_deposit;
                if(this.deposite_amount == 0 && this.full_amount != 0){
                    this.button1 = 'Close';
                    this.button2 = 'Pay balance'
                }
                else if(this.deposite_amount != 0){
                    this.button1 = 'Close';
                    this.button2 = 'Pay now'
                }
                var bookings = response.data.result.bookings;
                for(var booking_index = 0; booking_index < bookings.length; booking_index++){
                    if(bookings[booking_index].due_book_deposit == 0) this.payed_deposite += bookings[booking_index].book_deposit;
                    if(bookings[booking_index].due_book_fullamount <= 0) this.payed_full_amount += bookings[booking_index].book_fullamount;
                } 

                this.update_total_value();
            })
        },
        change_date(){
            document.getElementById('select_date').click();
        },
        create_customer(){
            this.$session.set('bookings_list_new_booking_page',this.multibooking);
            this.$session.set('has_products_in_page',true);
            this.$session.set('page_title',this.title);
            this.$router.push('/newcustomer');
        },
        edit_customer(){
            this.$session.set('bookings_list_new_booking_page',this.multibooking);
            this.$session.set('edit_cust_id',this.get_customer_info.customer_details[0].cust_id);
            this.$session.set('has_products_in_page',true);
            this.$session.set('page_title',this.title);
            this.$router.push('/editcustomer')
        },
        async add_service_card (add_card){
            var count=this.cards.length;

            if(count > 0){
                if(this.multibooking[count-1].serv_id == ''){
                    this.multibooking[count-1].error_message = 'Select the service before you choose the next step';
                }
                else this.multibooking[count-1].error_message='';
                var serv_start_time = moment(this.multibooking[count-1].serv_end_time, "HH:mm").add(this.multibooking[count-1].post_buffer, "minutes").format('HH:mm');
                var split_time = serv_start_time.split(":");
                var minutes = utils.round_to_near_5min(split_time[1]);
                if(parseInt(minutes) < 10) minutes = '0'+minutes;
                serv_start_time = split_time[0]+":"+minutes
                await this.check_slot_availability(count-1)
                if(this.multibooking[count-1].error_message.length == 0 && add_card == true){
                    this.cards.push({index:count,service_index:'S'+(count+1)});
                    this.multibooking.push({services_list:[],serv_id:'',user_id:this.staff[0].user_id,book_fullamount:'',book_deposit:0,serv_start_time:serv_start_time,serv_end_time:'End Time',serv_duration:'',pre_buffer:'',post_buffer:'',serv_cat_id:'',error_message:'',unmapped_selected_error:false,endtime_mismatch:false});
                    this.get_services_by_staff_id(this.staff[0].user_id,count);
                }
            }
            else{
                this.cards.push({index:count,service_index:'S'+(count+1)});
                this.multibooking.push({services_list:[],serv_id:'',user_id:this.staff[0].user_id,book_fullamount:'',book_deposit:0,serv_start_time:'',serv_end_time:'End Time',serv_duration:'',pre_buffer:'',post_buffer:'',serv_cat_id:'',error_message:'',unmapped_selected_error:false,endtime_mismatch:false});
                this.get_services_by_staff_id(this.staff[0].user_id,count)
            }
        },

        check_slot_availability(booking_index){
            var staff_id = this.multibooking[booking_index].user_id;
            var start_time = moment(this.multibooking[booking_index].serv_start_time,'hh:mm')
            var end_time = moment(this.multibooking[booking_index].serv_end_time,'hh:mm');
            var beforeTime = '';
            var afterTime = '';
            var slot_alredy_exist = false;
            if(this.multibooking.length > 1){
                if(this.multibooking[booking_index].error_message == '' && this.multibooking[booking_index].serv_id != ''){
                    this.re_check_slot_availability(booking_index);
                }
                if(this.multibooking[booking_index].serv_id != ''){
                    for(var index = 0 ; index < this.multibooking.length ; index++){
                        if(booking_index != index && this.multibooking[index].user_id == staff_id){
                            beforeTime = moment(this.multibooking[index].serv_start_time,'hh:mm');
                            afterTime = moment(this.multibooking[index].serv_end_time,'hh:mm');
                            if (start_time.isBetween(beforeTime, afterTime) || end_time.isBetween(beforeTime, afterTime) || start_time.isSame(beforeTime) || end_time.isSame(afterTime) || beforeTime.isBetween(start_time,end_time) || afterTime.isBetween(start_time,end_time)) {

                                this.multibooking[booking_index].error_message = 'Time slot is overlapping with another bookings please change accordingly';
                                slot_alredy_exist = true;
                            }
                         }
                    }
                    if(!slot_alredy_exist){
                        this.multibooking[booking_index].error_message = '';
                    }
                }
                else{
                    this.multibooking[booking_index].error_message = 'Select the service before you choose the next step';
                    if(booking_index != 0){
                        this.multibooking[booking_index].serv_start_time = this.multibooking[booking_index-1].serv_end_time;
                        this.multibooking[booking_index].serv_end_time = '';
                    }
                }
            }
            if(moment(this.multibooking[booking_index].serv_end_time,["HH:mm"]) < moment(this.multibooking[booking_index].serv_start_time,["HH:mm"]))
                    {
                        this.multibooking[booking_index].error_message = "End Time is exceeding selected date Please select other slot"
                    }
        },

        re_check_slot_availability(selected_index){
            for(var booking_index = 0;booking_index < this.multibooking.length;booking_index++){
                if(this.multibooking[booking_index].user_id == this.multibooking[selected_index].user_id){
                    var staff_id = this.multibooking[booking_index].user_id;
                    var start_time = moment(this.multibooking[booking_index].serv_start_time,'hh:mm')
                    var end_time = moment(this.multibooking[booking_index].serv_end_time,'hh:mm');
                    var beforeTime = '';
                    var afterTime = '';
                    var slot_alredy_exist = false;
                    
                    for(var index = 0 ; index < this.multibooking.length ; index++){
                        if(booking_index != index && this.multibooking[index].user_id == staff_id){
                            beforeTime = moment(this.multibooking[index].serv_start_time,'hh:mm');
                            afterTime = moment(this.multibooking[index].serv_end_time,'hh:mm');
                                if (start_time.isBetween(beforeTime, afterTime) || end_time.isBetween(beforeTime, afterTime) || start_time.isSame(beforeTime) || end_time.isSame(afterTime) || beforeTime.isBetween(start_time,end_time) || afterTime.isBetween(start_time,end_time)) {
                                slot_alredy_exist = true;
                            }
                        }
                    }
                    if(!slot_alredy_exist){
                        this.multibooking[booking_index].error_message = '';
                    }
                }
            }

        },


        getCustomers_list(){
            this.update_customer_array=true;
            if(this.cust_details.length > 2){
                this.customers_list=[];
                axios.post(this.$store.state.api + `get_customers_list`, {
                    "owner_id":this.$session.get('owner_id'),
                    "search_data":this.cust_details
                }).then(response => {
                    if(this.update_customer_array == true){
                        this.customers_list=response.data.result; 
                        this.update_customer_array = false;
                    }
                })
            }
            else this.customers_list=[];
        },

        get_customer_details(id){
            axios.post(this.$store.state.api + `get_details_of_customer`, {
                "owner_id":this.$session.get('owner_id'),
                "cust_id":id
            }).then(response => {
                this.$session.set('booking_customer_id',id)
                this.$store.state.loader_popup = false;
                this.get_customer_info = response.data.result;
                this.search_customer=true;
                if(this.get_customer_info.customer_details[0].send_email == 1) this.send_mail = true;
                if(this.get_customer_info.customer_details[0].send_text == 1) this.send_text = true;
                if(!this.get_customer_info.customer_details[0].cust_picture || (this.get_customer_info.customer_details[0].cust_picture != 'null')) this.get_customer_info.customer_details[0].cust_picture = '';
            })
        },

        //get services call to store.js and getiing the value
        async get_services_by_staff_id(staff_id,index,change_end_time_slot){
            await this.$store.dispatch('getServicesByStaffID',[this.$store.state.api,this.store_id,staff_id]);
            this.multibooking[index].services_list= this.$store.state.services_by_staff;
            this.$store.state.loader_popup = false;
            this.update_service_card_details(index,change_end_time_slot);
        },

        async get_staff(){
            await this.$store.dispatch('getStaffByStoreId',[this.$store.state.api,this.store_id]);
            this.staff=this.$store.state.store_staff_ids;
            if(this.multibooking.length)this.multibooking[0].user_id=this.staff[0].user_id;
            if(this.$session.has('selected_date'))this.booking_date = this.$session.get('selected_date');
            else this.booking_date = new Date();  
            if(this.title == 'New Booking'){
                if(this.$session.get('staff_selected') && this.$session.get('staff_id') != null){
                    this.multibooking[0].user_id = this.$session.get('staff_id');
                }
                if(!this.$session.get('service_start_time')) {
                    var today = new Date();
                    this.multibooking[0].serv_start_time = today.getHours() + ":" + utils.round_to_near_5min(today.getMinutes());
                    // this.multibooking[0].serv_start_time = moment(new Date()).format('HH:mm');
                }else{
                this.multibooking[0].serv_start_time = moment(this.$session.get('service_start_time'),["HH:mm"]).format('HH:mm');  
                }
                this.get_services_by_staff_id(this.multibooking[0].user_id,0);
            }
        },

        update_service_card_details(index,change_end_time_slot){
            if(this.multibooking[index].serv_id != ''){
                var service_id = this.multibooking[index].serv_id;
                this.multibooking[index].services_list.mapped_services.forEach(services => {
                    services.services.forEach(service=>{
                        if(service.serv_id == service_id){
                            this.multibooking[index].serv_duration = service.serv_defdur;
                            if(this.service_changed){
                                this.multibooking[index].book_deposit = service.serv_deposit;
                                this.multibooking[index].book_fullamount = service.serv_saleprice;
                                this.multibooking[index].pre_buffer = service.serv_prebuffertime;
                                this.multibooking[index].post_buffer = service.serv_postbuffertime;
                            }
                            this.multibooking[index].serv_cat_id = service.serv_cat_id;
                            this.multibooking[index].unmapped_selected_error = false;
                        }
                    })
                    
                });
                this.multibooking[index].services_list.unmapped_services.forEach(services => {
                    services.services.forEach(service=>{
                        if(service.serv_id == service_id){
                            this.multibooking[index].serv_duration=service.serv_defdur;
                            if(this.service_changed){
                                this.multibooking[index].book_deposit = service.serv_deposit;
                                this.multibooking[index].book_fullamount = service.serv_saleprice;
                                this.multibooking[index].pre_buffer = service.serv_prebuffertime;
                                this.multibooking[index].post_buffer = service.serv_postbuffertime;
                            }
                            this.multibooking[index].serv_cat_id = service.serv_cat_id;
                            this.multibooking[index].unmapped_selected_error = true;
                        }
                    })
                });
                if(change_end_time_slot == true)this.update_End_time(index, this.multibooking[index].serv_duration);

                this.update_total_value();
                
                if(this.multibooking[index].error_message != ""){
                    this.add_service_card(false);
                }
            }
            if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') this.update_button_text();
            this.service_changed = false;
        },
        service_updated(index,status){
            this.service_changed = true;
            // if(!this.multibooking[index].book_discount_full_amount){
                this.multibooking[index].book_discount_full_amount = -1;
            // }
            this.update_service_card_details(index,status);
        },
        update_End_time(index,serv_duration){
            if(this.multibooking[index].serv_id != '') this.multibooking[index].serv_end_time = moment(this.multibooking[index].serv_start_time,["HH:mm"]).add(serv_duration, 'minutes').format('HH:mm');
            if(this.multibooking[index].error_message != ""){
                this.add_service_card(false);
            }
            this.check_slot_availability(index);
            if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') this.update_button_text();
        },

        clear_customer_info(){
            this.search_customer=false;
            this.cust_details='';
            this.customers_list=[]
        },

        update_total_value(){
            this.booking_total = 0;
            this.multibooking.forEach(booking => {
                if(booking.book_discount_full_amount == -1){
                    this.booking_total += parseFloat(booking.book_fullamount);
                }
                else this.booking_total += parseFloat(booking.book_discount_full_amount);
            });
            this.$store.state.selected_products.forEach(product => {
                this.booking_total += parseFloat(product.selected_quantity)*parseFloat(product.product_sale_price)
            })

        },

        remove_card(index,type){
//            if(this.title == 'New Booking'){
//                this.multibooking.splice(index,1);
//                this.cards.splice(this.cards.length-1,1)
//                this.update_total_value();
//            }
//            else {
                this.popup_type = 'service_remove'
                this.remove_type = type;
                this.remove_service_index = index;
                this.remove_popup = true;
//            }
        },
        
        end_time_validation(index){
            var start_time = this.multibooking[index].serv_start_time;
            var duration = this.multibooking[index].serv_duration;
            var end_time = this.multibooking[index].serv_end_time;
            var difference = ((moment(end_time,["HH:mm"]) - moment(start_time,["HH:mm"]))/60)/1000
            if(difference <= 0){
                this.multibooking[index].serv_end_time = moment(this.multibooking[index].serv_start_time,["HH:mm"]).add(duration, 'minutes').format('HH:mm');
                this.multibooking[index].endtime_mismatch = false;
            }
            else if(duration > difference){
                this.multibooking[index].endtime_mismatch = true;
            }
            else this.multibooking[index].endtime_mismatch = false;
            this.check_slot_availability(index);
            if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') this.update_button_text();
        },

        buffer_updated(index){
            // JOYWEB-2621: Set up (pre_buffer) and Clean up (post_buffer) are editable on desktop web.
            // Normalise each to a non-negative whole number of minutes rounded to the nearest 5, matching
            // the Service Starts/Ends pickers (minute-step 5) and the mobile app's 5-minute picker.
            // Start times are edited independently via the pickers, so we deliberately do NOT auto-shift
            // sibling cards here (that would clobber user-set start times).
            var norm = function(v){
                v = parseInt(v);
                if(isNaN(v) || v < 0) return 0;
                return utils.round_to_near_5min(v);
            };
            this.multibooking[index].pre_buffer = norm(this.multibooking[index].pre_buffer);
            this.multibooking[index].post_buffer = norm(this.multibooking[index].post_buffer);
            if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') this.update_button_text();
        },

        // JOYWEB-2621: +/- stepper for the Set up / Clean up controls. field is 'pre_buffer'
        // or 'post_buffer'; delta is +/-5 min. Clamps at 0 and re-runs buffer_updated so the
        // value is normalised the same way as a direct edit.
        step_buffer(index, field, delta){
            var current = parseInt(this.multibooking[index][field]);
            if(isNaN(current)) current = 0;
            var next = current + delta;
            if(next < 0) next = 0;
            this.multibooking[index][field] = next;
            this.buffer_updated(index);
        },

        async update_customer_notes(){
            let cust_details = this.get_customer_info.customer_details;
            await this.$store.dispatch('update_customer_notes',[this.$store.state.api,cust_details[0].cust_id,this.$store.state.user_id,cust_details[0].cust_notes,this.$store.state.user_id])
            if(cust_details[0].cust_notes.length != 0){
                this.$refs.edit_cust_notes.innerHTML = 'Saved';
                this.$refs.edit_cust_notes.style.cssText="background: #10A377 !important";
            }
            this.save_cust_notes();  
        }, 

        edit_cust_notes(){
            this.edit_customer_notes = true;
            let _this = this;
            setTimeout(function(){
                _this.$refs.cust_notes.focus();
            },100);
        },

        save_cust_notes(){
            let _this = this;
            setTimeout(function(){
                _this.edit_customer_notes = false; 
            },700);

        },

        submit_booking(status){
            if(status == 'Close' || status == 'Cancel') {
                this.$session.remove('bookings_list_new_booking_page');
                this.$session.remove('booking_customer_id');
                this.$session.remove('page_title');
                this.$session.remove('previous_booking');
                this.$session.remove('previous_products');
                this.$session.remove('created_cust_id')
                this.$router.push('/calendar');}
            else if(status == 'Save changes' || status == 'Save Booking' || status =='unpay'){
                this.payment('Unpay');
            }
            else {
                this.payment('pay');
            }
        },

        payment(status){
            if(this.is_submitting) return; // JOYWEB-2801: block duplicate submits (double-tap / slow network)
            var booking_data= [];
            var count=this.cards.length;
            if(count > 0){
                if(this.multibooking[count-1].serv_id == ''){
                    this.multibooking[count-1].error_message = 'Select the service before you choose the next step';
                }
                else if(this.multibooking[count-1].error_message != 'End Time is exceeding selected date Please select other slot'){
                    this.$store.state.loader_popup = true;
                    for(var index=0;index < this.multibooking.length;index++){
                        booking_data.push({
                            "book_id":this.multibooking[index].book_id,
                            "multi_service_book_id":this.multibooking[index].multi_service_book_id,
                            "book_oldbookid":this.multibooking[index].book_oldbookid,
                            "serv_id" :this.multibooking[index].serv_id,
                            "serv_cat_id" :this.multibooking[index].serv_cat_id,
                            "user_id":this.multibooking[index].user_id,
                            "user_staff_type_id" :1,
                            "book_start_date":  moment(this.booking_date).format('yyyy-MM-DD'),
                            "book_end_date" :  moment(this.booking_date).format('yyyy-MM-DD'),
                            "book_start_time" : moment(this.multibooking[index].serv_start_time,["HH:mm"]).format('HH:mm:ss'),
                            "book_end_time" : moment(this.multibooking[index].serv_end_time,["HH:mm"]).format('HH:mm:ss'),
                            "book_duration" : this.multibooking[index].serv_duration,
                            "book_fullamount" :this.multibooking[index].serv_saleprice ? this.multibooking[index].serv_saleprice : this.multibooking[index].book_fullamount,
                            "book_deposit": this.multibooking[index].book_deposit,
                            "book_staff_note" : this.booking_staff_notes,
                        });
                        // JOYWEB-2621: always send the (now editable) buffers so New Booking persists
                        // them too — previously only Edit/Reschedule sent them, so New Booking silently
                        // fell back to the service defaults and cleanup-time edits were lost.
                        booking_data[index].serv_prebuffertime = parseInt(this.multibooking[index].pre_buffer) || 0;
                        booking_data[index].serv_postbuffertime = parseInt(this.multibooking[index].post_buffer) || 0;
                        if(this.multibooking[index].book_discount_full_amount || this.multibooking[index].book_discount_full_amount != -1){
                            booking_data[index].book_discount_full_amount = this.multibooking[index].book_discount_full_amount
                        }
                        if(this.multibooking[index].book_discount_deposit_amount || this.multibooking[index].book_discount_deposit_amount != -1){
                            booking_data[index].book_discount_deposit_amount = this.multibooking[index].book_discount_deposit_amount;
                        }
                    }
                    var product_details = {}
                    // JOYWEB-2801: rebuild the product payload fresh each attempt. It is a persistent
                    // data field, so without this reset a retry (after an error) would append the same
                    // products again and create duplicate product rows.
                    this.products_list = [];
                    if(this.title == 'New Booking'){
                        this.$store.state.selected_products.forEach(product => {
                            product_details={
                            "product_id": product.product_id,
                            "product_name":product.product_name,
                            "product_sku":product.product_sku,
                            "product_barcode":product.product_barcode,
                            "product_image_url":product.product_default_image.product_image_url,
                            "product_thumbnail_url":product.product_default_image.product_thumbnail_url,
                            "product_date":moment(this.booking_date).format('yyyy-MM-DD'),
                            "product_quantity": product.selected_quantity, 
                            "total_product_quantity":product.product_quantity,
                            "product_full_amount": product.product_sale_price, 
                            "product_book_status":200, 
                            "product_book_notes":this.booking_staff_notes
                        } 
                        this.products_list.push(product_details);
                        });
                    }
                    else{
                        this.$store.state.selected_products.forEach(product => {
                            if(!(product.booking_product_id))product.booking_product_id = '';
                            if(!(product.old_quantity))product.old_quantity = '';
                            product_details={
                                "booking_product_id":product.booking_product_id,
                                "product_id": product.product_id,
                                "product_name":product.product_name,
                                "product_sku":product.product_sku,
                                "product_barcode":product.product_barcode,
                                "product_image_url":product.product_default_image.product_image_url,
                                "product_thumbnail_url":product.product_default_image.product_thumbnail_url,
                                "product_date":moment(this.booking_date).format('yyyy-MM-DD'),
                                "product_quantity": product.selected_quantity, 
                                "old_quantity":product.old_quantity,
                                "remaining_product_quantity":(product.product_quantity - product.selected_quantity),
                                "total_product_quantity":product.product_quantity,
                                "product_full_amount": product.product_sale_price, 
                                "product_book_status":200, 
                                "product_book_notes":this.booking_staff_notes,
                                "booking_old_product_id":product.booking_old_product_id
                            } 
                            this.products_list.push(product_details);
                        });
                    }
                    var booking_type = 2;
                    if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') booking_type = this.$session.get('booking_type')
                    this.is_submitting = true; // JOYWEB-2801: set right before the POST (synchronous up to here)
                    axios.post(this.$store.state.api +'booking/insert',{
                    "store_id" :this.store_id,
                    "cust_id" :this.get_customer_info.customer_details[0].cust_id,
                    "book_first_name": this.get_customer_info.customer_details[0].cust_first_name,
                    "book_last_name": this.get_customer_info.customer_details[0].cust_last_name,
                    "book_email": this.get_customer_info.customer_details[0].cust_email,
                    "book_country_isd_code" : this.get_customer_info.customer_details[0].cust_country_isd_code,
                    "book_mobile" : this.get_customer_info.customer_details[0].cust_mobile,
                    "book_created_by":this.$store.state.user_id,
                    "booked_through": 1,
                    "book_updated_by":this.$session.get('owner_id'),
                    "updated_through": 1,
                    "booking_type":booking_type,
                    "save_unpaid_status":1,
                    "service_details":booking_data,
                    "product_details":this.products_list,
                    "sms_send":this.send_text,
                    "email_send":this.send_mail
                    }).then(response => {
                        this.is_submitting = false;
                        this.$session.remove('has_products_in_page');
                        this.$store.state.selected_products = [];
                        this.$store.state.loader_popup = false;
                        this.$session.remove('bookings_list_new_booking_page');
                        this.$session.remove('booking_customer_id');
                        this.$session.remove('page_title');
                        this.$session.remove('previous_booking');
                        this.$session.remove('previous_products');
                        this.$session.remove('created_cust_id')
                        this.$session.set('book_id',response.data.result.bookings[0].book_id)
                        if(this.title == 'Booking Reschedule' && this.multibooking.length >1)this.$session.set('multi_book_id',response.data.result.bookings[0].book_id)
                        else this.$session.set('multi_book_id',response.data.result.bookings[0].multi_book_id)
                        if(this.$session.get('rebook') == true){
                            this.$session.set('toast_title','Rebook Successful');
                        }
                        else this.$session.set('toast_title','Booking Successful');
                        this.$session.set('toast_message','Appointment saved as unpaid');
                        this.$session.set('show_toast',true);
                        if(status == 'pay'){
                            var payment_details = {
                                "cust_id":this.get_customer_info.customer_details[0].cust_id,
                                "book_id":response.data.result.bookings[0].book_id,
                                "multi_book_id":response.data.result.bookings[0].multi_book_id
                            }
                            if(this.title == 'Booking Reschedule' && this.multibooking.length >1)payment_details.multi_book_id = payment_details.book_id;
                            this.$session.set('payment_details',payment_details);
                            this.$router.push('/payment');
                        }
                        else{
                            this.$router.push('/viewbooking');
                        }

                    }, () => {
                        // JOYWEB-2801: release the guard + loader on failure so the user can retry
                        this.is_submitting = false;
                        this.$store.state.loader_popup = false;
                    })
                }
            }
        },

        remove_popup_card(){
            this.remove_popup = false;
        },

        remove_service_card(){
            if(this.multibooking[this.remove_service_index].book_id){
             this.$store.commit('service_status_update',[this.multibooking[this.remove_service_index].book_id,0,this.Constants.STATUS_EARLY_CANCELLED,this.$store.state.user_id,this.Constants.BOOKED_THROUGH_ADMIN,this.Constants.EDIT_FLAG]);
            }
            if(this.multibooking.length == this.previous_booking_details.length)this.previous_booking_details.splice(this.remove_service_index,1);
             this.cards.splice(this.cards.length-1,1);
             this.multibooking.splice(this.remove_service_index,1);
             this.update_total_value(); 
             this.remove_popup = false;
             if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule') this.update_button_text();
         },

        update_booking_notes(){
            if(this.multibooking.length){
                if(this.multibooking[0].book_id != '' && this.multibooking[0].book_id != undefined){
                    axios.post(this.$store.state.api +'booking/update_booking_notes',{
                    "book_id":this.multibooking[0].book_id,
                    "book_notes":this.booking_staff_notes,
                    "multi_service_book_id":this.multibooking[0].multi_service_book_id
                    })
                }  
            }
        },

        update_button_text(){
            this.changes_happened = false;
            if(this.multibooking.length != this.previous_booking_details.length){
                this.changes_happened = true
            }else{
                for(var booking_index = 0; booking_index < this.multibooking.length; booking_index++){
                    if(this.multibooking[booking_index].serv_id != this.previous_booking_details[booking_index].serv_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].book_id != this.previous_booking_details[booking_index].book_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].multi_service_book_id != this.previous_booking_details[booking_index].multi_service_book_id){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].book_fullamount != this.previous_booking_details[booking_index].book_fullamount){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].book_deposit != this.previous_booking_details[booking_index].book_deposit){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].serv_start_time != this.previous_booking_details[booking_index].serv_start_time){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].serv_end_time != this.previous_booking_details[booking_index].serv_end_time){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].user_id != this.previous_booking_details[booking_index].user_id){
                        this.changes_happened = true;
                        break;
                    }
                    // JOYWEB-2621: a buffer-only edit (Set up / Clean up) is a real change too.
                    if(this.multibooking[booking_index].pre_buffer != this.previous_booking_details[booking_index].pre_buffer){
                        this.changes_happened = true;
                        break;
                    }
                    if(this.multibooking[booking_index].post_buffer != this.previous_booking_details[booking_index].post_buffer){
                        this.changes_happened = true;
                        break;
                    }
                }
            }
            if(!this.changes_happened){
                if(this.previous_products.length != this.$store.state.selected_products.length){
                    this.changes_happened = true;
                }else{
                    for(var product_index = 0;product_index < this.previous_products.length;product_index++){
                        if(this.previous_products[product_index].product_id != this.$store.state.selected_products[product_index].product_id){
                            this.changes_happened = true;
                            break;
                        }
                        if(this.previous_products[product_index].selected_quantity != this.$store.state.selected_products[product_index].selected_quantity){
                            this.changes_happened = true;
                            break;
                        }
                        if(!this.$store.state.selected_products[product_index].booking_product_id){
                            this.changes_happened = true;
                            break
                        }
                        else if(this.previous_products[product_index].booking_product_id != this.$store.state.selected_products[product_index].booking_product_id){
                            this.changes_happened = true;
                            break
                        }
                    }
                }
            }
            if(moment(this.booking_date).format('dddd, MMM D YYYY') != moment(this.previous_booking_date).format('dddd, MMM D YYYY'))this.changes_happened = true;
            var book_deposite = 0;
            var book_full_amount = 0;
            this.button1 = '';
            this.button2 = '';
            for(var index = 0; index < this.multibooking.length; index++){
                book_deposite += this.multibooking[index].book_deposit;
                book_full_amount += this.multibooking[index].book_fullamount;
            }
            var pending_deposite = book_deposite - this.payed_deposite;
            var pending_full_amount = book_full_amount - this.payed_full_amount;
            if(pending_full_amount <= 0)
            {   
                this.button1 = 'Close';
                if(this.changes_happened)this.button2 = 'Save changes' 
            }
            if(pending_deposite > 0){
                this.button1 = 'Close';
                this.button2 = 'Pay Now';
                if(this.changes_happened)this.button1 = 'Save Booking'                 
            }else if(pending_full_amount > 0){
                this.button1 = 'Close';
                if(this.changes_happened)this.button1 = 'Save Booking' 
                this.button2 = 'Pay Now';
            }
            else this.button1 = 'Close'
            if(this.$session.get('booking_type') == this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING){if(this.button1 == 'Close'){this.button1 = 'Cancel'}}
        },

        //product section
        hide_products_model(){
            this.show_product_model = false;
            this.$session.remove('bookings_list_new_booking_page');
            this.update_total_value();
        },
        show_products_model_popup(){
            this.$session.set('bookings_list_new_booking_page',this.multibooking);
            this.$session.set('page_title',this.title);
            this.$session.set('previous_booking',this.previous_booking_details);
            this.$session.set('previous_products',this.previous_products);
            this.show_product_model = true
        },
        change_quantity(index,status){
            this.$store.state.selected_products[index].selected_quantity = parseFloat(this.$store.state.selected_products[index].selected_quantity);
            if(status == 'add'){
                if(!(this.$store.state.selected_products[index].selected_quantity > this.$store.state.selected_products[index].product_quantity)){
                    this.$store.state.selected_products[index].selected_quantity = this.$store.state.selected_products[index].selected_quantity + 1;
                }
            }else if(status == 'remove' && this.$store.state.selected_products[index].selected_quantity <=1){
                return ;
            }
            else if(status == 'remove') 
                this.$store.state.selected_products[index].selected_quantity = this.$store.state.selected_products[index].selected_quantity - 1;
            if(this.$store.state.selected_products[index].selected_quantity > this.$store.state.selected_products[index].product_quantity) this.$store.state.selected_products[index].selected_quantity = this.$store.state.selected_products[index].product_quantity;
            if(this.$store.state.selected_products[index].selected_quantity <= 0){
                this.$store.state.selected_products.splice(index,1); 
            }
            this.update_total_value();
            if(this.title == 'Edit Booking' || this.title  == 'Booking Reschedule')this.update_button_text();
        },
        remove_product(index){
            this.selected_product_index =index;
            if(this.title == 'New Booking'){
                this.$store.state.selected_products.splice(index,1); 
                this.update_total_value();
                // this.update_button_text();
            }
            else{
                this.popup_type = 'product_remove';
                this.remove_service_index = 0;
                this.remove_popup = true;
            }
        },
        remove_selected_product(){
            if(this.$store.state.selected_products[this.selected_product_index].booking_product_id){
                this.$store.state.loader_popup = true;
                axios.post(this.$store.state.api+`v2/products/update_product_booking_status_v2`,{
                    "booking_product_id":this.$store.state.selected_products[this.selected_product_index].booking_product_id,
                    "book_status":this.Constants.STATUS_EARLY_CANCELLED,
                    "updated_by": this.$session.get('owner_id'),
                    "updated_through":1
                }).then(response => {
                    console.log(response.data.status);
                    this.$store.state.loader_popup = false;
                    if((this.$store.state.selected_products.length == this.previous_products.length) && (this.$store.state.selected_products[this.selected_product_index].product_id == this.previous_products[this.selected_product_index].product_id))this.previous_products.splice(this.selected_product_index,1);
                    this.$store.state.selected_products.splice(this.selected_product_index,1); 
                    this.update_total_value();
                    this.update_button_text();
                    this.remove_popup =false;
                })
            }
            else{
                this.$store.state.selected_products.splice(this.selected_product_index,1); 
                this.update_total_value();
                this.update_button_text();
                this.remove_popup = false
            }
        }

    }
}